<template>
  <el-dialog class="default-auth" width="600px" title="默认权限" :visible.sync="dialogShow" append-to-body :modal-append-to-body="false" :close-on-click-modal="false">
    <div class="alert" style="margin-top: -15px;margin-bottom: 30px;">
      <i class="iconfont icon-circle-warning" style="color: #409EFF;font-size: 16px"></i>
      <div class="content">
        为用户设置默认权限后，该用户扫码绑定设备后，将自动获得默认权限，无需再为该用户逐台设备授权。
      </div>
    </div>

    <el-form ref="postForm" label-position="left" label-width="80px" style="padding: 0 50px" :model="formData">
      <el-form-item label="用户">
        <div class="flex align-items-center">
          <f-user-avatar :src="formData.avatar" class="hd" shape="rounded" />
          <span v-overflow-tooltip class="ml bd ellipsis">{{ formData.nickname }}</span>
        </div>
      </el-form-item>

      <el-form-item label="权限" prop="default_auth">
        <el-select v-model="formData.default_auth" clearable placeholder="选择权限" style="width: 200px;">
          <el-option v-for="item in authArr" :key="item.value" v-if="item.value > 0" :label="item.title" :value="item.value" />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="text-center mb">
      <el-button class="extend" @click="cancel">取消</el-button>
      <el-button class="extend" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { postMemberProfileApi } from "@/api/up/upMemberApi";

export default {
  name: "DefaultAuthDialog",

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    row: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      formData: {},
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    authArr() {
      return this.$store.state.userStore.is_frippler ? this.$store.state.rmsStore.authArr : this.$store.state.rmsStore.authArr.slice(0, 6);
    },
  },

  watch: {},

  created() {
    this.formData = Object.assign({},this.row);
    if (this.row.default_auth === 0) {
      this.formData.default_auth = "";
    }
  },

  methods: {
    submit() {
      const temp = {
        default_auth: this.formData.default_auth
          ? this.formData.default_auth
          : 0,
        memberid: this.formData.memberid,
      };

      postMemberProfileApi(temp).then((res) => {
        if (!res.errno) {
          this.$message.success("设置成功");
          this.$emit("success");
          this.dialogShow = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    cancel() {
      this.dialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.default-auth {
  .alert {
    width: 100%;
    padding: 8px 16px;
    margin: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    background-color: #ecf5ff;
    color: #101010;
    overflow: hidden;
    opacity: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: opacity 0.2s;
    transition: opacity 0.2s;
    .content {
      display: table-cell;
      padding: 0 8px;
      font-size: 14px;
    }
  }
}
</style>
